export default __webpack_public_path__ + "static/media/icon-seal.f3c37bf0.png";